import React, { useEffect, useContext } from 'react';
import './fashion.scss';
import DialogContentText from '@material-ui/core/DialogContentText';
import ReactMarkdown from 'react-markdown';

// CONTEXT
import ActivitiesContext from '../../../../../contexts/pages/activities/activitiesContext';

const Fashion = () => {

    const activitiesContext = useContext(ActivitiesContext);
    const { fashionShow } = activitiesContext;

    useEffect(() => {
    }, [fashionShow])

    return (
        <div className="mnu activity-subpage">
            <div className="mnu-inner act">
                <div className="mnu-title">{fashionShow ? fashionShow.titulo.toUpperCase() : "MODELO DE LAS NACIONES UNIDAS"}</div>
                <div className="mnu-text">
                    {fashionShow
                        ?
                        // <DialogContentText>
                            <ReactMarkdown>
                                {fashionShow.contenido}
                            </ReactMarkdown>
                        // </DialogContentText>
                        :
                        <p>
                            La Secundaria Babeque es un centro educativo auspiciado por la Fundación Pedagógica Dominicana Inc.,
                            institución sin fines de lucro creada en el año de 1977  por un grupo de madres y padres cuyos hijos
                            terminaban el sexto grado del Colegio Babeque Inicial y Primaria. Con esta iniciativa se proponían
                            velar por el desarrollo de los valores universales, la dominicanidad y la formación integral de sus hijos e hijas.

                            Se seleccionó el nombre Babeque, voz de origen taíno que significa tierra de oro, por considerar a
                            la niñez y la juventud como la esperanza y el tesoro más preciado de una nación.
                        </p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Fashion;